module.exports = __webpack_public_path__ + "img/Randy Price.8738d964.jpg";